export default __webpack_public_path__ + "assets/models/a094799ef80fa8764b5ec29f80e9f279.glb";